import { Pipe, PipeTransform } from '@angular/core';
import { UserSummary } from './user-summary.model';

@Pipe({
    name: 'filterPersona',
    pure: false
})
export class FilterPersonaPipe implements PipeTransform {
    transform(items: UserSummary[], filter): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return items.filter(item => item.persona.indexOf(filter.name) !== -1);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/users/filter-persona.pipe.ts